import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Input, Menu, Dropdown } from 'semantic-ui-react';
import { exportOrders } from '../actions';
import { OrderFilter } from '../config';

class OrderMenu extends Component {
    state = {
        activeItem: ''
    }

    handleExportClick = (e) => this.props.exportOrders(true);

    handleFilterClick(cat, e) {
        this.props.history.push('/orders/' + cat);
    }

    render() {
        const { activeItem } = this.state;
        const { filter } = this.props.order;
        console.log(filter)

        return (
            <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }} >
                <Dropdown item text='Filter'>
                <Dropdown.Menu>
                {
                    OrderFilter.map((cat) => (
                        <Dropdown.Item key={cat} text={cat} active={filter===cat} onClick={this.handleFilterClick.bind(this, cat)}/>
                    ))
                }
                </Dropdown.Menu>
                </Dropdown>

                <Menu.Item name='messages' active={activeItem === 'messages'} onClick={this.handleExportClick.bind(this)}>
                    <Icon name='download' />
                    Export
                </Menu.Item>
            </Menu>
        )
    }
}

const mapStateToProps = ({ order }) => {
    return { order }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        exportOrders: exportOrders
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(OrderMenu);